<div id="photo-selection-toolbar" class="flex justify-between items-center">
    <section
      id="photo-selection-count"
      class="rounded-2xl bg-neptune-color-primary-600 px-3 py-2 shadow-neptune-elevation-1 text-white"
    >
      <span class="text-sm font-medium">
        Total Photos Selected : {{ selectedCount }}
      </span>
    </section>

    <section id="photo-selection-bar-actions" class="flex gap-6">
      <button
        id="photo-clear-selections-button"
        [ngClass]="
          selectedCount === 0
            ? 'neptune-button-disabled'
            : 'neptune-button-white'
        "
        (click)="clearAllSelections()"
      >
        <img
          src="/assets/shared-icons/neptune-icon-blue-close.svg"
          alt="Clear All"
          class="w-6 h-6 self-center"
        />
        Clear All
      </button>
      <download-button
        id="photo-download-button"
        [disabled]="disabled"
        [status]="status"
        [labels]="labels"
        [icons]="{
          idle: 'assets/download-icon-white.svg',
          running: 'assets/download-icon-white.svg',
          success: 'assets/download-icon-white.svg',
          error: 'assets/download-icon-white.svg',
        }"
        (start)="onDownload()"
      />
    </section>
  </div>

